// extracted by mini-css-extract-plugin
module.exports = {"lhsWrapper":"LoginLhs_lhsWrapper__lXRMg","login1":"LoginLhs_login1__1kYU-","welcome":"LoginLhs_welcome__14aDB","logo":"LoginLhs_logo__2vl0f","lhsText":"LoginLhs_lhsText__2o9M-"};